/**
 * Footer "Cookie-Einstellungen": reopens Shopify's cookie banner preferences
 * (window.privacyBanner). If the banner is not loaded for this visitor, falls
 * back to the URL in data-fallback-url (the privacy policy).
 */
class CookiePreferences extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const button = this.querySelector('button');
    button?.addEventListener('click', () => {
      const banner = window.privacyBanner;
      if (banner && typeof banner.showPreferences === 'function') {
        banner.showPreferences();
        return;
      }
      if (this.dataset.fallbackUrl) {
        window.location.href = this.dataset.fallbackUrl;
      }
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-cookie-preferences')) {
  customElements.define('s-cookie-preferences', CookiePreferences);
}
